import type { OrderStatus } from '../api/orders';

export const statusBadgeCx = (status: OrderStatus): string => {
  const base = 'inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide';
  const map: Record<OrderStatus, string> = {
    initiated: 'bg-slate-100 text-slate-600',
    draft: 'bg-blue-100 text-blue-700',
    approved: 'bg-indigo-100 text-indigo-700',
    confirmed: 'bg-cyan-100 text-cyan-700',
    in_progress: 'bg-amber-100 text-amber-800',
    completed: 'bg-green-100 text-green-700',
    verified: 'bg-emerald-100 text-emerald-700',
    done: 'bg-purple-100 text-purple-700',
    delivered: 'bg-teal-100 text-teal-700',
    cancelled: 'bg-rose-100 text-rose-700',
  };
  return `${base} ${map[status] ?? 'bg-slate-100 text-slate-600'}`;
};

